<template>
	<div v-if="adminApi">
		<CEntryDetailsLightbox
			v-for="(item, index) in state.stack"
			:key="item.id"
			:lightbox-id="item.id"
			:admin-api="adminApi"
			:entry-id="item.entryId"
			:form-id="item.formId"
			:view-id="item.viewId"
			:view-token="item.viewToken"
			:role-id="item.roleId"
			:title="item.title"
			:can-edit="item.canEdit"
			:telemetry="item.telemetry ?? null"
			:default-tab="item.defaultTab"
			:person-email="item.personEmail"
			:style="{ zIndex: 1000 + index }"
			@close="handleClose(index)"
		/>
	</div>
</template>

<script lang="ts">
	import { defineComponent, onBeforeUnmount, watch } from 'vue';
	import { useRoute } from 'vue-router/composables';
	import CEntryDetailsLightbox from './EntryDetailsLightbox.vue';
	import { useEntryDetailsLightboxState, useEntryDetailsLightboxAdminApi, useEntryDetailsLightbox } from 'src/views/entries/entry-details/use-entry-details-lightbox';
	import { injectAdminFormApi, adminNamespace } from 'src/views/admin/utils/admin-api';
	import { globalStore } from 'src/stores/global-store';

	export default defineComponent({
		name: 'CEntryDetailsLightboxContainer',
		components: {
			CEntryDetailsLightbox
		},
		setup() {
			const state = useEntryDetailsLightboxState();
			const adminApi = useEntryDetailsLightboxAdminApi();
			const { closeEntryDetailsLightboxByIndex, closeAllEntryDetailsLightboxes } = useEntryDetailsLightbox();
			const route = useRoute();

			const destroyMountedLightboxForm = (formId: string) => {
				if (formId && adminApi.value)
					void adminApi.value.destroy(formId);
			};

			watch(() => state.open, async (open) => {
				if (!open || adminApi.value)
					return;

				const existing = (window as unknown as Record<string, unknown>)[adminNamespace];
				if (existing) {
					adminApi.value = existing as typeof adminApi.value;
					return;
				}

				const apiKey = globalStore.organization?.FormClientApiKey;
				if (!apiKey)
					return;

				await injectAdminFormApi(apiKey);
				const injected = (window as unknown as Record<string, unknown>)[adminNamespace];
				if (injected)
					adminApi.value = injected as typeof adminApi.value;
			}, { immediate: true });

			watch(() => route.fullPath, () => {
				if (state.stack.length > 0)
					closeAllEntryDetailsLightboxes();
			});

			const handleClose = (index: number) => {
				closeEntryDetailsLightboxByIndex(index);
			};

			onBeforeUnmount(() => {
				// Destroy all forms in the stack
				for (const item of state.stack) {
					if (item.formId)
						destroyMountedLightboxForm(item.formId);
				}
				adminApi.value = null;
				state.stack = [];
				state.open = false;
			});

			return {
				state,
				adminApi,
				handleClose
			};
		}
	});
</script>
